import React from 'react';
import { graphql } from 'gatsby';
import styled from 'styled-components';
import { RichText } from 'prismic-reactjs';

import { Row, Col } from './grid-system';
import bp from '../assets/js/breakpoints';
import { createTranslation } from '../assets/js/utilities';

import Link from './Link';
import Image from './Image';
import Heading from './Heading';

const FeaturedEventCallout = React.forwardRef(
  ({ content, lang, noImage, fullWidth }, ref) => {
    const {
      url,
      data: { start_day, title, featured_excerpt, featured_image },
    } = content;

    return (
      <Row center="xs" className="featured-event-wrapper">
        <Col base={12} lg={fullWidth ? 12 : 10} ref={ref}>
          <FeaturedEventWrapper
            aria-label={createTranslation('Featured Event', lang)}
            fullWidth={fullWidth}
          >
            <Link url={{ url: url, link_type: 'Document' }}>
              <Row>
                {!noImage && (
                  <Col base={12} sm={6}>
                    <Image image={featured_image} aspectRatio={16 / 9} />
                  </Col>
                )}

                <Col base={12} sm={fullWidth ? 12 : 6}>
                  <EventOverview>
                    <p>{start_day}</p>
                    <Heading level="h2" size="m" content={title} />
                    <RichText render={featured_excerpt.richText} />
                    <p className="link-text">
                      {createTranslation('Details', lang)}
                    </p>

                    {!noImage && (
                      <FeaturedEventText
                        width="107"
                        height="107"
                        viewBox="0 0 107 107"
                        fill="#9F17D4"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <title>
                          {createTranslation('Featured Event', lang)}
                        </title>
                        <path d="M21.0182 13.5168L17.2591 17.1463L19.3893 19.3992L22.6472 16.2703L23.7749 17.3967L20.517 20.5256L23.399 23.5293L22.146 24.7809L14.8783 17.1463L19.8905 12.2653L21.0182 13.5168ZM28.9124 16.6457L33.5486 13.642L34.4258 15.0187L28.2859 19.0237L22.6472 10.1376L28.6618 6.38291L29.5389 7.75963L25.028 10.6382L26.5316 13.0162L30.2907 10.6382L31.1679 12.0149L27.4087 14.3929L28.9124 16.6457ZM42.5705 12.1401L41.1922 10.3879L36.8065 12.0149V14.2677L35.0523 14.8935L35.3029 3.62947L37.0572 2.87853L44.3248 11.5143L42.5705 12.1401ZM36.6812 10.1376L40.0645 9.01119L36.8065 5.00619L36.6812 10.1376ZM50.59 0.125095L50.8406 1.75213L47.4574 2.25275L48.7104 11.0137L46.8309 11.264L45.5778 2.50306L42.1946 3.00369L41.944 1.2515L50.59 0.125095ZM54.0985 -6.10352e-05L55.8528 0.125095L55.3515 6.50806C55.2262 8.00994 56.1034 9.13634 57.7323 9.2615C59.236 9.38666 60.3637 8.51056 60.489 6.88353L60.9902 0.500564L62.7445 0.62572L62.2433 7.00869C62.118 8.26025 61.6167 9.2615 60.7396 10.0124C59.8625 10.7634 58.7347 11.0137 57.4817 10.8885C56.2287 10.7634 55.2262 10.2628 54.4744 9.51181C53.7226 8.63572 53.472 7.63447 53.5973 6.38291L54.0985 -6.10352e-05ZM69.5109 13.642L69.0097 9.38666L66.6289 8.63572L65.3759 12.2653L63.6216 11.6395L67.0048 1.62697L71.2652 3.00369C72.2676 3.37916 73.0194 3.87978 73.3953 4.63072C73.7712 5.38166 73.8965 6.25775 73.5206 7.259C73.0194 8.63572 72.017 9.38666 70.7639 9.51181L71.3905 14.1426L69.5109 13.642ZM68.2579 3.87978L67.1301 7.00869L69.5109 7.75963C70.5133 8.13509 71.3905 7.63447 71.7664 6.75838C72.1423 5.88228 71.6411 5.00619 70.6386 4.63072L68.2579 3.87978ZM75.2749 14.5181L80.0364 17.3967L79.034 18.7734L72.7688 15.0187L78.1569 6.00744L84.2968 9.63697L83.4196 11.1388L78.9087 8.38541L77.5303 10.7634L81.4148 13.1413L80.5377 14.5181L76.6532 12.1401L75.2749 14.5181ZM90.3114 14.6432C91.4391 15.7696 92.0656 17.0212 92.0656 18.3979C92.0656 19.7746 91.5644 21.0262 90.4367 22.1526C89.3089 23.279 88.0559 23.9048 86.6775 23.9048C85.2992 23.9048 84.0462 23.279 82.7931 22.1526L80.1617 19.6495L87.5547 12.1401L90.3114 14.6432ZM83.9209 20.901C84.6727 21.652 85.5498 22.0274 86.4269 22.0274C87.3041 22.0274 88.1812 21.652 88.933 20.901C89.6848 20.1501 90.0608 19.274 90.0608 18.3979C90.0608 17.5218 89.6848 16.6457 88.933 15.8948L87.68 14.6432L82.6678 19.7746L83.9209 20.901ZM91.6897 30.4129L94.3211 35.294L92.8174 36.0449L89.3089 29.662L98.5814 24.5306L101.965 30.7884L100.461 31.5393L97.9549 26.9085L95.5741 28.2852L97.7043 32.1651L96.326 32.916L94.1958 29.0362L91.6897 30.4129ZM105.598 41.3015L106.1 43.1788L94.9476 42.5531L94.3211 40.3002L103.468 33.7921L103.969 35.6695L96.326 40.926L105.598 41.3015ZM97.8296 48.936L98.2055 54.4429L96.5766 54.5681L95.95 47.1838L106.476 46.5581L106.851 53.692L105.223 53.8171L104.972 48.5606L102.215 48.6857L102.466 53.1913L100.837 53.3165L100.586 48.8109L97.8296 48.936ZM105.598 64.5806L105.348 66.3327L94.9476 64.5806L95.3235 62.5781L103.969 59.0737L96.2006 57.697L96.4513 55.9448L106.851 57.697L106.476 59.6995L97.8296 63.2038L105.598 64.5806ZM100.837 77.9723L99.3332 77.3465L100.712 74.2176L92.5668 70.7132L93.3187 69.0862L101.463 72.5906L102.842 69.4616L104.345 70.0874L100.837 77.9723ZM85.5498 93.4916L89.4342 89.9873L87.3041 87.7345L84.0462 90.7382L82.9184 89.6118L86.1763 86.608L83.4196 83.4791L84.798 82.2276L91.9403 89.9873L86.8028 94.7432L85.5498 93.4916ZM77.781 90.1124L73.0194 92.991L72.1423 91.6143L78.4075 87.8596L83.7956 96.8709L77.6557 100.5L76.7785 98.9985L81.2895 96.2451L79.9111 93.8671L76.0267 96.1199L75.1496 94.7432L79.034 92.4904L77.781 90.1124ZM63.9975 94.3677L65.3759 96.1199L69.8868 94.618L70.0121 92.3652L71.7664 91.7395L71.2652 103.004L69.2603 103.629L62.2433 94.8684L63.9975 94.3677ZM69.8868 96.4954L66.5036 97.6218L69.7615 101.752L69.8868 96.4954ZM55.7275 106.132L55.4768 104.505L58.8601 104.13L57.8576 95.369L59.6119 95.1187L60.6143 103.88L64.1228 103.504L64.3734 105.131L55.7275 106.132ZM52.0936 106.132L50.3394 105.882L51.0912 99.4991C51.2165 97.9973 50.3394 96.8709 48.8357 96.6206C47.3321 96.4954 46.2043 97.3715 45.9537 98.8734L45.2019 105.256L43.4477 105.006L44.1995 98.6231C44.3248 97.3715 44.826 96.3702 45.7031 95.7445C46.5803 95.1187 47.708 94.7432 48.961 94.9935C50.2141 95.1187 51.2165 95.6193 51.9683 96.4954C52.7202 97.3715 52.9708 98.3727 52.8455 99.7495L52.0936 106.132ZM37.0572 92.2401L37.5584 96.4954L39.9391 97.3715L41.3175 93.742L43.0717 94.3677L39.4379 104.255L35.1776 102.628C34.1752 102.253 33.5486 101.752 33.0474 100.876C32.6715 100.125 32.6715 99.2488 32.9221 98.2476C33.4233 96.996 34.4258 96.1199 35.6788 96.1199L35.0523 91.4891L37.0572 92.2401ZM38.1849 102.002L39.3126 98.8734L36.9319 97.9973C35.9294 97.6218 35.0523 97.9973 34.6764 98.9985C34.3005 99.8746 34.8017 100.751 35.8041 101.126L38.1849 102.002ZM31.4185 91.1137L26.7822 88.1099L27.6594 86.7332L33.7993 90.6131L28.1606 99.4991L22.146 95.6193L23.0231 94.2426L27.5341 97.1212L29.0377 94.7432L25.2786 92.3652L26.1557 90.9885L29.9148 93.3665L31.4185 91.1137ZM16.382 90.6131C15.2543 89.4866 14.753 88.2351 14.753 86.8584C14.753 85.4817 15.3796 84.2301 16.5073 83.1037C17.635 81.9773 18.8881 81.4766 20.2664 81.4766C21.6448 81.4766 22.8978 82.1024 24.0255 83.2288L26.5316 85.8571L19.0134 93.2413L16.382 90.6131ZM22.8978 84.4804C22.146 83.7295 21.2689 83.354 20.3917 83.354C19.5146 83.354 18.6375 83.7295 17.8856 84.4804C17.1338 85.2313 16.7579 86.1074 16.7579 86.9835C16.7579 87.8596 17.1338 88.7357 17.8856 89.4866L19.1387 90.7382L24.2761 85.732L22.8978 84.4804ZM15.3796 74.8434L12.8735 69.9623L14.3771 69.2113L17.7603 75.7195L8.36254 80.6006L5.10463 74.3427L6.60828 73.5918L8.98906 78.3477L11.4951 77.0962L9.36497 73.0912L10.7433 72.0899L12.8735 76.0949L15.3796 74.8434ZM1.72143 63.5793L1.22021 61.702L12.3723 62.7032L12.9988 64.956L3.72629 71.2138L3.22507 69.3365L10.9939 64.2051L1.72143 63.5793ZM9.74088 56.1951L9.61558 50.6882H11.2445L11.4951 57.9473L0.969602 58.3227L0.718994 51.1888H2.34795L2.47325 56.4454L5.35524 56.3202L5.22994 51.8146H6.85889L6.98419 56.3202L9.74088 56.1951ZM2.34795 40.3002L2.72386 38.5481L13.1241 40.5506L12.6229 42.5531L3.85159 45.9323L11.6204 47.4342L11.2445 49.1863L0.844298 47.1838L1.22021 45.1813L9.99149 41.8021L2.34795 40.3002ZM7.48541 27.0337L8.98906 27.7846L7.48541 30.9135L15.5049 34.5431L14.753 36.1701L6.73359 32.5406L5.22994 35.6695L3.85159 35.0437L7.48541 27.0337Z" />
                      </FeaturedEventText>
                    )}
                  </EventOverview>
                </Col>
              </Row>
            </Link>
          </FeaturedEventWrapper>
        </Col>
      </Row>
    );
  }
);

export default FeaturedEventCallout;

/**
 * Styled Components
 *
 */
const FeaturedEventWrapper = styled.section`
  margin-bottom: ${props => (props.fullWidth ? 0 : '8rem')};

  @media (${bp.min.sm}) {
    margin-bottom: ${props => (props.fullWidth ? 0 : 'var(--space-xxl)')};
  }

  &:hover {
    a {
      color: var(--color-black);
    }

    @media (hover: hover) {
      .link-text {
        color: var(--color-neon-green);

        &:after {
          transform: translateX(0.4rem);
        }
      }

      img {
        transform: scale(1.025);
      }
    }
  }

  .image-wrapper {
    height: 100%;
  }

  .image {
    height: 100%;

    img {
      will-change: transform;
      transition: all 500ms var(--ease-cubic-in-out);
    }
  }
`;

const EventOverview = styled.div`
  position: relative;
  background-color: var(--color-white);
  flex: 1 0 50%;
  height: 100%;
  padding: var(--space-m) var(--space-m);

  @media (${bp.min.sm}) {
    padding: var(--space-l) var(--space-m);

    &:before {
      content: '';
      background-color: var(--color-white);
      position: absolute;
      left: -3.2rem;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: -1;
    }
  }

  .heading-tag {
    margin: var(--space-s) 0 var(--space-m);

    @media (${bp.min.sm}) {
      margin: var(--space-m) 0;
    }
  }

  p {
    max-width: 38ch;
  }

  .link-text {
    --margin-top: var(--space-s);
    margin-top: var(--margin-top);
    color: var(--color-black);
    transition: color 200ms var(--ease-quart-in-out);

    @media (${bp.min.sm}) {
      --margin-top: var(--space-xl);
    }

    &:after {
      content: '→';
      display: inline-block;
      margin-left: var(--space-xxxs);
      transition: transform 400ms var(--ease-quart-in-out);
    }
  }
`;

const FeaturedEventText = styled.svg`
  position: absolute;
  top: 100%;
  right: 0;
  transform: translate(50%, -50%);
  animation: rotateEventText 30s infinite forwards linear;

  @media (${bp.min.sm}) {
    top: 0;
    right: 9.6rem;
  }

  @keyframes rotateEventText {
    0% {
      transform: translate(50%, -50%) rotate(0deg);
    }
    100% {
      transform: translate(50%, -50%) rotate(360deg);
    }
  }
`;

/**
 * GraphQL Query
 *
 */
export const query = graphql`
  fragment FeaturedEvent on PrismicEvent {
    url
    lang
    data {
      title
      tags {
        event_type
      }
      featured_image {
        alt
        gatsbyImageData(width: 1680)
        url
      }
      featured_background_color
      featured_excerpt {
        richText
        text
      }
      start
      end
      all_day
      cost
      recurring_event
      frequency
      interval
      recurring_end
      excluded_dates {
        date
      }
      location {
        venue
        address {
          richText
          text
        }
        google_maps_url
        website {
          url
        }
      }
    }
  }
`;
